import axios from 'axios'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { TOAST_UTILS } from 'src/consumer/constants'
import {
  appInstallationId,
  appVersion,
  getApiServerUrlObject,
  platformWeb,
  getMainLanguageCode,
  getCountryCode,
} from 'src/consumer/services'

export const supportApiURL = getApiServerUrlObject().url

export const commonHeadersMPWeb = {
  'ef-app-version': appVersion,
  'ef-app-platform': platformWeb,
  'ef-app-package': 'com.aumhum.mentor',
  'ef-app-installation-id': appInstallationId,
  'ef-device-model': 'iPad11,6',
  'ef-device-os-version': '16',
  'ef-device-manufacturer': 'apple',
  'ef-user-city': 'moscow',
  get ['ef-session-id']() {
    return sessionStorage.getItem('sessionId')
  },
  get ['ef-device-os-language']() {
    return (navigator?.language || navigator?.userLanguage || 'en').split('-')[0]
  },
}

export const useFetchMP = (path, customParams = '', platformType) => {
  const [state, setState] = useState({ loading: true, data: null, error: null })

  const [countryCode, setCountryCode] = useState(localStorage.getItem('countryCode'))

  useEffect(() => {
    function handleChangeStorage() {
      setCountryCode(localStorage.getItem('countryCode'))
    }

    window.addEventListener('storage', handleChangeStorage)
    return () => window.removeEventListener('storage', handleChangeStorage)
  }, [])

  const mainLanguageCode = getMainLanguageCode()
  const token = localStorage.getItem('token')

  useEffect(() => {
    setState({ loading: true, data: null, error: null })

    const effectiveCountryCode = getCountryCode()
    const paramsWeb = `languageCode=${mainLanguageCode}&platform=${platformWeb}&countryCode=${effectiveCountryCode}`

    let params = paramsWeb

    axios
      .get(`${supportApiURL}${path}?${params}${customParams}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          ...commonHeadersMPWeb,
          'ef-user-country-code': effectiveCountryCode,
          'ef-app-language': mainLanguageCode,
        },
      })
      .then((res) => {
        setState({ data: res.data, loading: false, error: null })
      })
      .catch((error) => {
        setState({ data: null, loading: false, error: error })
      })
  }, [path, customParams, token, countryCode, mainLanguageCode])
  return state
}

export async function getSPDataWithoutParams(url) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    const res = await axios.get(`${supportApiURL}${url}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        ...commonHeadersMPWeb,
        'ef-user-country-code': countryCode,
        'ef-app-language': mainLanguageCode,
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function postSPDataWithoutParams(url, data) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    const res = await axios.post(`${supportApiURL}${url}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        ...commonHeadersMPWeb,
        'ef-user-country-code': countryCode,
        'ef-app-language': mainLanguageCode,
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

// Phase 14g — DELETE helper for the support API. Mirrors the auth + locale headers pattern
// the rest of the support service helpers use, with optional query params (apiParams) so the
// caller can scope the delete by practitioner-id / type / etc.
export async function deleteSPDataWithParams(url, apiParams) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    const res = await axios.delete(`${supportApiURL}${url}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        ...commonHeadersMPWeb,
        'ef-user-country-code': countryCode,
        'ef-app-language': mainLanguageCode,
      },
      params: apiParams || {},
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}
export async function postSPFormDataWithoutParams(url, formData) {
  const token = localStorage.getItem("token")
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    const res = await axios.post(`${supportApiURL}${url}`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        ...commonHeadersMPWeb,
        "ef-user-country-code": countryCode,
        "ef-app-language": mainLanguageCode,
        "Content-Type": "multipart/form-data",
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}
export async function patchSPDataWithParams(url, data, params = {}) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    const res = await axios.patch(`${supportApiURL}${url}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        ...commonHeadersMPWeb,
        'ef-user-country-code': countryCode,
        'ef-app-language': mainLanguageCode,
      },
      params: { ...params },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}
export async function postSPDataWithParams(url, data, params = {}, loadingTst) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    const res = await axios.post(`${supportApiURL}${url}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        ...commonHeadersMPWeb,
        'ef-user-country-code': countryCode,
        'ef-app-language': mainLanguageCode,
      },
      params: { ...params },
    })
    return res
  } catch (err) {
    console.log(err)
    toast.update(loadingTst, {
      ...TOAST_UTILS,
      render: 'Something went wrong',
      type: toast.TYPE.ERROR,
      isLoading: false,
    })
    return err
  }
}

export async function getSPData(url) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    const res = await axios.get(
      `${supportApiURL}${url}?languageCode=${mainLanguageCode}&platform=${platformWeb}&countryCode=${countryCode}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          ...commonHeadersMPWeb,
          'ef-user-country-code': countryCode,
          'ef-app-language': mainLanguageCode,
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function getSPDataWithParams(url, apiParams) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    const res = await axios.get(`${supportApiURL}${url}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        ...commonHeadersMPWeb,
        'ef-user-country-code': countryCode,
        'ef-app-language': mainLanguageCode,
      },
      params: {
        languageCode: mainLanguageCode,
        platform: platformWeb,
        countryCode: countryCode,
        ...apiParams,
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function postSPData(url, data) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    // const os = `${platform.os.family}`.toLowerCase()
    const res = await axios.post(
      `${supportApiURL}${url}?languageCode=${mainLanguageCode}&platform=${platformWeb}&countryCode=${countryCode}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          ...commonHeadersMPWeb,
          'ef-user-country-code': countryCode,
          'ef-app-language': mainLanguageCode,
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export function getToken() {
  const token = localStorage.getItem('token')
  return token
}

export async function putSPDataWithoutParams(url, data) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    const res = await axios.put(`${supportApiURL}${url}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        ...commonHeadersMPWeb,
        'ef-user-country-code': countryCode,
        'ef-app-language': mainLanguageCode,
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function putSPDataWithParams(url, data, params = {}, customHeaders = {}) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    const res = await axios.put(`${supportApiURL}${url}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        ...commonHeadersMPWeb,
        ...customHeaders,
        'ef-user-country-code': countryCode,
        'ef-app-language': mainLanguageCode,
      },
      params,
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}
